
import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from "lucide-react";
import { StockActions } from "../StockActions";
import { InventoryMode } from "../inventory/InventoryMode";

interface StockHeaderActionsProps {
  onOpenDeleteDialog: () => void;
  onOpenAddDialog: () => void;
  onOpenRestockDialog: () => void;
  onOpenCart: () => void;
  onOpenLossDialog: () => void;
  stockItems: any[];
  onInventoryComplete: () => void;
  onInventoryStart: () => void;
  isInventoryActive: boolean;
  buttonVisibility: {
    cart: boolean;
    restock: boolean;
    return: boolean;
    quantity: boolean;
    actions: boolean;
    inventory: boolean;
    loss: boolean;
    delete: boolean;
    add: boolean;
  };
}

export const StockHeaderActions = ({
  onOpenDeleteDialog,
  onOpenAddDialog,
  onOpenRestockDialog,
  onOpenCart,
  onOpenLossDialog,
  stockItems,
  onInventoryComplete,
  onInventoryStart,
  isInventoryActive,
  buttonVisibility,
}: StockHeaderActionsProps) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row gap-2 justify-end">
        {buttonVisibility.add && (
          <Button onClick={onOpenAddDialog} className="w-full sm:w-auto">
            <Plus className="w-4 h-4 mr-2" />
            Ajouter un produit
          </Button>
        )}
        {buttonVisibility.cart && (
          <StockActions onOpenCart={onOpenCart} />
        )}
      </div>

      <InventoryMode 
        stockItems={stockItems}
        onInventoryComplete={onInventoryComplete}
        onInventoryStart={onInventoryStart}
        isInventoryActive={isInventoryActive}
        buttonVisibility={buttonVisibility}
        renderActions={(isInventoryActive) => (
          <div className={`flex flex-col sm:flex-row gap-2 justify-end ${isInventoryActive ? 'hidden' : ''}`}>
            <div className="flex flex-col sm:flex-row gap-2">
              {buttonVisibility.delete && (
                <Button 
                  variant="outline" 
                  onClick={onOpenDeleteDialog}
                  className="text-red-500 hover:text-red-600 hover:bg-red-50 w-full sm:w-auto"
                >
                  <Trash2 className="w-4 h-4 mr-2" />
                  Supprimer un produit
                </Button>
              )}
            </div>
          </div>
        )}
      />
    </div>
  );
};
